(function() {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings.membership', {
            parent: 'settings',
            url: '/membership',
            data: {
                roles: ['ROLE_ADMIN', 'ROLE_MANAGER']
            },
            views: {
                'content@app': {
                    templateUrl: 'app/settings/membership/membership.html',
                    controller: 'MembershipController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    //$translatePartialLoader.addPart('settings.tables');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
